import MyAiChatMessagesAPI from 'dashboard/api/my_ai/myAiChatMessages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'MyAiChatMessages',
  API: MyAiChatMessagesAPI,
  getters: {
    getMessagesByThreadId: state => myAiChatThreadId => {
      return state.records
        .filter(
          record => record.my_ai_chat_thread?.id === Number(myAiChatThreadId)
        )
        .sort((a, b) => a.id - b.id);
    },
  },
  actions: mutationTypes => ({
    upsert({ commit }, data) {
      commit(mutationTypes.UPSERT, data);
    },
  }),
});
